import { z } from 'zod';

/**
 * A Whacky Whale (or any NFT) held by the signed-in wallet — used as the
 * subject reference for an image-to-image generation.
 *
 * `imageUrl` is the public URL of the NFT's image (IPFS-gateway or Arweave
 * resolved by the indexer). FLUX Kontext fetches this URL when generating;
 * the wallet of the user doesn't need to upload anything.
 */
export const WhaleSchema = z.object({
  tokenId: z.number().int().nonnegative(),
  name: z.string(),
  imageUrl: z.string().url(),
  /**
   * Small indexer-CDN thumbnail for grid display — far lighter than the full
   * `imageUrl`, so a large pod (hundreds of whales) renders fast. Display only;
   * generation always uses the full `imageUrl`. Absent for some tokens, so
   * consumers fall back to `imageUrl`.
   */
  thumbnailUrl: z.string().url().optional(),
  /** Optional traits passed through for display + future kit derivation. */
  traits: z
    .array(
      z.object({
        type: z.string(),
        value: z.string(),
      }),
    )
    .default([]),
});
export type Whale = z.infer<typeof WhaleSchema>;

/** The Whacky Whales contract on Ethereum mainnet. Locked, do not change. */
export const WHACKY_WHALES_CONTRACT = '0x9c890d7e4d9becb20f7b612d5df3c4157a0837dc';
export const WHACKY_WHALES_CHAIN_ID = 1;
